export const navs_zh = {
    // title: '我的',
    array: [
      {
        key: '1',
        title: '权限管理',
        array: [
          {
            key: '1_1',
            title: '权限申请',
            route: '/personal/permissionApply',
            array: []
          },
          {
            key: '1_2',
            title: '数据推送设置',
            route: '/personal/dataPushSetting',
            array: []
          }
        ]
      },
      {
        key: '2',
        title: '其他',
        array: [
          {
            key: '2_1',
            title: '问题反馈',
            route: '/personal/helpFeedback',
          }
        ]
      }
    ]
  }

  export const navs_en = {
    // title: 'My',
    array: [
      {
        key: '1',
        title: 'Access Managemennt',
        array: [
          {
            key: '1_1',
            title: 'Apply Access',
            route: '/personal/permissionApply',
            array: []
          },
          {
            key: '1_2',
            title: 'Data Push Setting',
            route: '/personal/dataPushSetting',
            array: []
          }
        ]
      },
      {
        key: '2',
        title: 'Others',
        array: [
          {
            key: '2_1',
            title: 'Feedback',
            route: '/personal/helpFeedback',
          }
        ]
      }
    ]
  }